"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInfoIcon = isInfoIcon;
var _constants = require("./constants");
function isInfoIcon(type) {
  return _constants.ALLOWED_INFO_ICONS.includes(type);
}